import React, { useState, useEffect, useRef } from "react";
import { Card } from "antd";
import ResilientImage from "../ResilientImage/ResilientImage";
import "./PhotoCard.css"
import { useTranslation } from "../../i18n";

const PhotoCard = ({ src, title, isPortrait, index = Infinity }) => {
    const { t } = useTranslation();
    const priority = index < 3;
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [showDetails, setShowDetails] = useState(false);
    const cardRef = useRef(null);
    const showTimerRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!isMobile) {
            setShowDetails(false);
            return undefined;
        }

        const clearShowTimer = () => {
            if (showTimerRef.current) {
                clearTimeout(showTimerRef.current);
                showTimerRef.current = null;
            }
        };

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    clearShowTimer();
                    showTimerRef.current = setTimeout(() => {
                        setShowDetails(true);
                    }, 2000);
                } else {
                    clearShowTimer();
                    setShowDetails(false);
                }
            },
            { threshold: 1.0 }
        );

        if (cardRef.current) {
            observer.observe(cardRef.current);
        }

        return () => {
            clearShowTimer();
            observer.disconnect();
        };
    }, [isMobile]);

    return (
        <div
            ref={cardRef}
            className="photo-card-container"
            onMouseEnter={() => !isMobile && setShowDetails(true)}
            onMouseLeave={() => !isMobile && setShowDetails(false)}
        >
            <Card
                hoverable
                className={"photo-card"}
                bodyStyle={{ display: 'none' }}
                cover={
                    <div className="photo-image-container">
                        <ResilientImage
                            className="photo-image"
                            alt={title}
                            src={src}
                            loading={priority ? "eager" : "lazy"}
                            decoding="async"
                            fetchPriority={priority ? "high" : "auto"}
                        />
                    </div>
                }
            />
            <div className={`overlay ${showDetails ? 'show' : ''}`}>
                <span className="overlay-action">{t("common.view")}</span>
            </div>
        </div>
    );
};

export default PhotoCard;
